import { render, staticRenderFns } from "./CustomDocFieldsGrid.vue?vue&type=template&id=ba1945be&"
import script from "./CustomDocFieldsGrid.vue?vue&type=script&lang=js&"
export * from "./CustomDocFieldsGrid.vue?vue&type=script&lang=js&"
import style0 from "./CustomDocFieldsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports